<template>
  <v-container fluid>
    <v-layout column class="mentions-container">
      <h1 class="text-uppercase">Mentions légales</h1>
      <span class="primary--text font-weight-medium">Éditeur du site internet</span>
      <p class="font-weight-bold">MC Consultant</p>
      <p>Société par actions simplifiée au capital de 1 500,00 €</p>
      <p>Immatriculée au R.C.S. de Chaumont sous le numéro 842 255 812 00021</p>
      <p>Siège social : 8, avenue Raoul LAURENT – 52100 SAINT-DIZIER</p>

      <span class="primary--text font-weight-medium">Hébergeur du site internet</span>
      <p class="font-weight-bold">OVH</p>
      <p>Société par actions simplifiée au capital de 10 174 560,00 €</p>
      <p>Immatriculée au R.C.S. de Lille Métropole sous le numéro 424 761 419 00045 - Code APE 2620Z</p>
      <p>Siège social : 2, rue Kellermann – 59100 ROUBAIX</p>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'mentions-legales',
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="stylus">
.mentions-container
  padding-left: 85px
  margin-top: 32px

.mentions-container h1
  font-size: 1.8rem
  // margin-bottom: 32px

.mentions-container span
  font-size: 16px

.mentions-container span
  margin: 32px 0 16px 0

.mentions-container p
  margin-bottom: 8px
  font-size: 14px

/* Style for medium devices */
.mdOnly .mentions-container h1
  font-size: 1.6rem

.mdOnly .mentions-container span
  font-size: 16px

.mdOnly .mentions-container p
  font-size: 14px

.smOnly .mentions-container,
.xsOnly .mentions-container
  padding: 0 !important

/* Style for small devices */
.smOnly .mentions-container
  margin: 32px 0

.smOnly .mentions-container h1
  text-align: center
  font-size: 1.6rem

.smOnly .mentions-container p,
.smOnly .mentions-container span
  padding: 0 60px

.smOnly .mentions-container span
  margin: 40px 0 16px 0
  font-size: 16px

.smOnly .mentions-container p
  margin-bottom: 6px 0
  font-size: 14px

/* Style for extra small devices */
.xsOnly .mentions-container
  margin: 16px 0

.xsOnly .mentions-container h1
  font-size: 1.2rem
  text-align: center

.xsOnly .mentions-container p,
.xsOnly .mentions-container span
  font-size: 12px
  padding: 0 32px

.xsOnly .mentions-container span
  margin: 24px 0 16px 0
  font-size: 14px

.xsOnly .mentions-container p
  font-size: 13px
</style>

